var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccelerationEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Acceleration Events",
    role: "img",
    viewBox: "0 0 100 87",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Acceleration Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9989,7.779c-2.7122-0.0223-5.2351,1.385-6.6379,3.7028L8.9172,67.3659 c-2.2547,3.6592-1.1116,8.4504,2.5532,10.7017c1.2284,0.7546,2.6424,1.1539,4.0847,1.1535h68.8875 c4.3028,0.0012,7.7919-3.4806,7.7931-7.7768c0.0004-1.44-0.3995-2.8519-1.1553-4.0784L56.6368,11.4818 C55.234,9.1641,52.7111,7.7567,49.9989,7.779 M49.9989,0.0001c5.4088-0.0166,10.4325,2.7923,13.2446,7.4056l34.4438,55.8841 c4.5094,7.3183,2.2231,16.9009-5.1064,21.4033c-2.4478,1.5036-5.2643,2.302-8.1382,2.3069H15.5551 C6.9495,86.9852-0.0148,80.0078,0,71.4154c0.0049-2.8695,0.8046-5.6817,2.3105-8.1257L36.7543,7.4056 C39.5664,2.7924,44.5901-0.0165,49.9989,0.0001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1002,57.0353c-2.1514,0-3.8955-1.7414-3.8955-3.8895V28.401c0-2.1481,1.7441-3.8895,3.8955-3.8895 s3.8955,1.7414,3.8955,3.8895v24.7371c0.0043,2.1481-1.7363,3.893-3.8877,3.8973C50.1054,57.0353,50.1028,57.0353,50.1002,57.0353z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1002,73.2467c-2.1514,0-3.8955-1.7414-3.8955-3.8895l0,0v-3.2361c0-2.1481,1.7441-3.8895,3.8955-3.8895 c0,0,0,0,0,0c2.1514,0,3.8955,1.7414,3.8955,3.8895v3.2361C53.9957,71.5054,52.2516,73.2467,50.1002,73.2467 C50.1002,73.2467,50.1002,73.2467,50.1002,73.2467z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerationEvents);
export default __webpack_public_path__ + "static/media/acceleration-events.fc691dda22a0640791544811a8859335.svg";
export { ForwardRef as ReactComponent };